export default __webpack_public_path__ + "static/media/gaxon.59f5815e.woff";